import { StateCreator } from 'zustand';

export interface UserSlice {
  isAuthenticated: boolean | null;
  setAuthenticated: (isAuthenticated: boolean | null) => void;
  user: Record<string, unknown> | null;
  setUser: (user: Record<string, unknown> | null) => void;
  setVaultId: (vaultId: string) => void;
}

export interface ProfileSlice {
  profile: Record<string, unknown> | null;
  setProfile: (profile: Record<string, unknown>) => void;
}

export interface TokenSlice {
  token: string | null;
  setToken: (token: string | null) => void;
}

export const userSlice: StateCreator<UserSlice> = (set) => ({
  isAuthenticated: false,
  setAuthenticated: (isAuthenticated: boolean | null) =>
    set(() => ({ isAuthenticated })),
  user: null,
  setUser: (user: Record<string, unknown> | null) => set(() => ({ user })),
  setVaultId: (vaultId: string) => set((state) => {
    if (!state.user) {
      return { user: { user: { vaultId } } };
    }
    
    const updatedUser = { ...state.user };
    
    if (!updatedUser.user) {
      updatedUser.user = { vaultId };
    } else {
      updatedUser.user = {
        ...(updatedUser.user as Record<string, unknown>),
        vaultId
      };
    }
    
    return { user: updatedUser };
  }),
});

export const profileSlice: StateCreator<ProfileSlice> = (set) => ({
  profile: null,
  setProfile: (profile: Record<string, unknown> | null) =>
    set(() => ({ profile })),
});

export const tokenSlice: StateCreator<TokenSlice> = (set) => ({
  token: null,
  setToken: (token: string | null) => set(() => ({ token })),
});
